import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { v4 as uuid } from 'uuid';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

@Component({
  selector: 'fin-product-expand',
  templateUrl: 'product-expand.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductExpandComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() title: string;

  open = false;
  id: string;

  ngOnInit(): void {
    this.id = uuid();
  }
}
